import { render, staticRenderFns } from "./check-build-version.vue?vue&type=template&id=40da872d"
import script from "./check-build-version.vue?vue&type=script&lang=js"
export * from "./check-build-version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports